import { connectorByIdQuery } from 'src/services/DOM/queries/connectorById/__generated__/connectorByIdQuery.graphql';
import { OverviewType } from '../../../../OverviewCard';
import { printLocalDatetimeWithTimezone } from 'src/products/connector/utils/printLocalDatetimeWithTimezone';
import { BuildDestinationsOverviewReturn } from './model';

export const buildDestinationsOverview = (
  models: connectorByIdQuery['response']['connector']['models']
): BuildDestinationsOverviewReturn[] =>
  models.flatMap((model) =>
    model.destinations.map((destination) => {
      return {
        type: OverviewType.DESTINATION,
        name: destination.name,
        displayName: destination.displayName,
        revision: 'Latest',
        provider: destination.provider,
        created: printLocalDatetimeWithTimezone(
          'MMM D YYYY h:mm A',
          model.createdAt
        ),
        creator: 'Cherre',
      };
    })
  );
